import 'lib-flexible/flexible.js'
import '@/assets/css/normalize.css'

import App from './App.vue'
import {Utils} from '@/assets/js/utils'
import {Weixin} from '@/assets/js/weixin'
// import VConsole from 'vconsole'
import Vue from 'vue'

Vue.prototype.Utils = Utils;
Vue.prototype.Weixin = Weixin;

Vue.config.productionTip = false;

// export default new VConsole();

new Vue({
    render: h => h(App)
}).$mount('#app')
